import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    preaspirantes: [],
    aspirantes: [],
    preaspiranteParaValidacion: null,
    aspiranteParaValidacion: null,
  },

  getters: {
    getPreaspirantes: (state) => state.preaspirantes.filter((preaspirante) => preaspirante),

    getAspirantes: (state) => state.aspirantes,

    getPreaspiranteParaValidacion: (state) => state.preaspiranteParaValidacion,

    getAspiranteParaValidacion: (state) => state.aspiranteParaValidacion,
  },
  mutations: {
    SET_PREASPIRANTES(state, preaspirantes) {
      state.preaspirantes = preaspirantes;
    },

    SET_ASPIRANTES(state, aspirantes) {
      state.aspirantes = aspirantes;
    },

    SET_PREASPIRANTE_PARA_VALIDACION(state, idPersonal) {
      const preaspiranteParaValidacion = state.preaspirantes.filter(
        (preaspirante) => preaspirante.idPersonal === idPersonal,
      );

      const preaspirante = { ...preaspiranteParaValidacion[0] };

      state.preaspiranteParaValidacion = preaspirante;
    },

    SET_ASPIRANTE_PARA_VALIDACION(state, idPersonal) {
      const aspiranteParaValidacion = state.aspirantes.filter(
        (aspirante) => aspirante.idPersonal === idPersonal,
      );

      const aspirante = { ...aspiranteParaValidacion[0] };
      state.aspiranteParaValidacion = aspirante;
    },
  },
  actions: {
    async fetchPreaspirantes({ commit }) {
      await axios
        .get('/PoliciaCuadrantes/EstadoFuerza/preAspirante')
        .then((response) => {
          commit('SET_PREASPIRANTES', response.data.data);
        });
    },

    async fetchAspirantes({ commit }) {
      await axios
        .get('/PoliciaCuadrantes/EstadoFuerza/pendientesBiometricos')
        .then((response) => {
          commit('SET_ASPIRANTES', response.data.data);
        });
    },

    async savePreaspirante(context, preaspirante) {
      await axios
        .post('/PoliciaCuadrantes/EstadoFuerza/personal', preaspirante.data)
        .then((response) => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Preaspirante registrado correctamente.', {
            root: true,
          });
          preaspirante.estudios.forEach((estudio) => {
            // eslint-disable-next-line no-param-reassign
            estudio.fk_idPersonal = response.data.data[0].ID;
            context.dispatch('estudio/saveEstudiosPersonal', estudio, { root: true });
          });
        });
    },
  },
};
